export default "__VITE_ASSET__CSy3X9l5__"